import { Injectable } from '@angular/core';
import { Headers, RequestOptions } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { EnvironmentConfiguration } from '../../environment/services/environment.configuration';
import { ResponseUtilService } from '../../shared/utils/response-util.service';
import { TransientReservationSearchParameters } from '../models/transient-reservation-search-params';
import { Reservation, TransientReservation } from '../models/reservation';
import { LinkReservationRequest } from '../models/link-reservation-request';
import { AppAuthHttpService } from '../../http/app.auth.http.service';
import { Page } from '../../shared/models/page';

@Injectable()
export class TransientReservationService {

  private eventUrl: string = this.environment.baseUrl + '/api/events';

  constructor(private http: AppAuthHttpService,
              private environment: EnvironmentConfiguration,
              private responseUtilService: ResponseUtilService) {
  }

  search(searchParameters: TransientReservationSearchParameters, page: number, size: number): Observable<Page<TransientReservation>> {
    const headers = new Headers({ 'Content-Type': 'application/json' });
    const options = new RequestOptions({ headers: headers }); // Create a request option
    const reservationAsJSON = JSON.stringify(searchParameters.toJS());

    return this.http.post(`${this.eventUrl}/transient/reservations/search?page=${page}&size=${size}`, reservationAsJSON, options)
      .map(response => response.json())
      .catch(response => this.responseUtilService.handleError(response))
      .share();
  }

  linkTransientReservationToEvent(eventReservationId: number, eventId: number, doNotPay?: boolean): Observable<Reservation> {
    let result;
    const headers = new Headers({ 'Content-Type': 'application/json' });
    const options = new RequestOptions({ headers: headers });
    const request = new LinkReservationRequest({
      eventReservationId: eventReservationId,
      eventId: eventId,
      payViaGp: doNotPay ? false : true
    });
    const requestAsJSON = JSON.stringify(request);
    result = this.http.post(`${this.eventUrl}/transient/reservations/link-to-event`, requestAsJSON, options)
      .map(response => new Reservation(response))
      .catch(response => this.responseUtilService.handleError(response))
      .share();
    return result;
  }

  unlinkTransientReservation(eventReservationId: number, eventId: number): Observable<Reservation> {
    let result;
    const headers = new Headers({ 'Content-Type': 'application/json' });
    const options = new RequestOptions({ headers: headers });
    const request = new LinkReservationRequest({
      eventReservationId: eventReservationId,
      eventId: eventId
    });
    const requestAsJSON = JSON.stringify(request);
    result = this.http.post(`${this.eventUrl}/transient/reservations/unlink`, requestAsJSON, options)
      .map(response => new Reservation(response))
      .catch(response => this.responseUtilService.handleError(response))
      .share();
    return result;
  }

}



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/GroupPay/jobs/QA2/jobs/QA-Pioneer-ALL-2-POC/workspace/pioneer-web/src/app/event/service/transient-reservation-http-service.ts